var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.49 22.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,4.62V0H18.49V4.62H0Zm18.49,1.85v15.72H0V6.47H18.49Zm-3.7,9.17H3.7v1.93H14.79v-1.93Zm0-2.77H3.7v1.93H14.79v-1.93Zm0-2.77H3.7v1.93H14.79v-1.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.ff95f5d146b297b3ff37a01524959d60.svg";
export { ForwardRef as ReactComponent };